<div class="no-elements-container">
  @if (icon) {
    <i class="pi {{ icon }}" id="no-elements-icon"></i>
  }
  @if (text) {
    <h4>{{ text }}</h4>
  }
</div>
